import { Redirect } from "react-router-dom/cjs/react-router-dom.min"
import Dashboard from "../Dashboard/Dashboard"
import "./LandingPage.css"
import { APP_DIRECTORY } from "../SystemVariables"

const LandingPage = (props) => {
    if(props.accessToken) {
        return(<Redirect to={`${APP_DIRECTORY}/soundboard`}/>)
    } else {
        return(<div className="landingPage">
            <Dashboard landingDashboard={true} clearLoginData={()=>{}}/>
        </div>)
    }
}

export default LandingPage
